
    <template>
      <section class="content element-doc">
        <h2 id="table-biao-ge"><a class="header-anchor" href="#table-biao-ge">¶</a> Table 表格</h2>
<p>基础属性和使用方法参考 <a href="https://element.eleme.cn/#/zh-CN/component/table">element-ui </a> <code>el-table</code> 组件文档</p>
<div class="tip">
<p>TableMixin 不是必须项，导入可以减少代码书写量</p>
</div>
<h3 id="wan-zheng-gong-neng"><a class="header-anchor" href="#wan-zheng-gong-neng">¶</a> 完整功能</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;ShTable
    ref=&quot;shTableRef&quot;
    :data=&quot;tableData&quot;
    :total=&quot;total&quot;
    :page-sizes=&quot;[ 20, 30, 40]&quot;
    layout=&quot;sizes, prev, pager, next,total&quot;
    :current-page.sync=&quot;pageIndex&quot;
    @page-current-change=&quot;pageChange&quot;
    @size-change=&quot;pageSizeChange&quot;
  &gt;
    &lt;el-table-column type=&quot;seq&quot; width=&quot;60&quot;&gt;&lt;/el-table-column&gt;
    &lt;el-table-column prop=&quot;name&quot; label=&quot;Name&quot;&gt; &lt;/el-table-column&gt;
    &lt;el-table-column prop=&quot;sex&quot; label=&quot;Sex&quot;&gt; &lt;/el-table-column&gt;
    &lt;el-table-column prop=&quot;age&quot; label=&quot;Age&quot;&gt;
      &lt;template v-slot=&quot;{row}&quot;&gt;{{row.age}}&lt;/template&gt;
    &lt;/el-table-column&gt;
  &lt;/ShTable&gt;
&lt;/template&gt;
&lt;script&gt;
  // 不是必须项导入可以减少代码书写量
  // import TableMixin from 'sh-ui-v2/packages/mixins/TableMixin'
  const TableMixin = require('#/mixins/TableMixin').default
  export default {
    data() {
      return {
        tableData: [
          { id: 10001, name: 'Test1', role: 'Develop', sex: 'Man', age: 28, address: 'test abc' },
          { id: 10002, name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
          { id: 10003, name: 'Test3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
          { id: 10004, name: 'Test4', role: 'Designer', sex: 'Women', age: 24, address: 'Shanghai' }
        ],
        total: 100
      }
    },
    mixins: [TableMixin],
    created() {
      this.getTableList()
    },
    mounted() {
      // 获取表格事件
      // console.log(this.$refs.shTableRef.$refs.elTableRef)
      // 获取分页器事件
      // console.log(this.$refs.shTableRef.$refs.elPaginationRef)
    },
    methods: {
      // 获取表格基础数据
      // 组件内重写getTableList方法，覆盖mixin内此方法
      getTableList() {
        // 获取表格数据
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="bu-xu-yao-fen-ye"><a class="header-anchor" href="#bu-xu-yao-fen-ye">¶</a> 不需要分页</h3>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;ShTable
    :pageShow=&quot;false&quot;
    :data=&quot;tableData&quot;
    :total=&quot;total&quot;
    :page-sizes=&quot;[10, 20, 30, 40]&quot;
    layout=&quot;sizes, prev, pager, next,total&quot;
    :current-page.sync=&quot;pageIndex&quot;
    @page-current-change=&quot;pageChange&quot;
    @size-change=&quot;pageSizeChange&quot;
  &gt;
    &lt;el-table-column type=&quot;seq&quot; width=&quot;60&quot;&gt;&lt;/el-table-column&gt;
    &lt;el-table-column prop=&quot;name&quot; label=&quot;Name&quot;&gt;
      &lt;template v-slot=&quot;{row}&quot;&gt;{{row.name}}&lt;/template&gt;
    &lt;/el-table-column&gt;
    &lt;el-table-column prop=&quot;sex&quot; label=&quot;Sex&quot;&gt;
      &lt;template v-slot=&quot;{row}&quot;&gt;{{row.sex}}&lt;/template&gt;
    &lt;/el-table-column&gt;
    &lt;el-table-column prop=&quot;age&quot; label=&quot;Age&quot;&gt;
      &lt;template v-slot=&quot;{row}&quot;&gt;{{row.age}}&lt;/template&gt;
    &lt;/el-table-column&gt;
  &lt;/ShTable&gt;
&lt;/template&gt;
&lt;script&gt;
  const TableMixin = require('#/mixins/TableMixin').default
  export default {
    data() {
      return {
        tableData: [
          { id: 10001, name: 'Test1', role: 'Develop', sex: 'Man', age: 28, address: 'test abc' },
          { id: 10002, name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
          { id: 10003, name: 'Test3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
          { id: 10004, name: 'Test4', role: 'Designer', sex: 'Women', age: 24, address: 'Shanghai' }
        ],
        total: 100
      }
    },
    mixins: [TableMixin],
    created() {
      this.getTableList()
    },
    methods: {
      // 获取表格基础数据
      getTableList() {}
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="zhi-xian-shi-biao-ge"><a class="header-anchor" href="#zhi-xian-shi-biao-ge">¶</a> 只显示表格</h3>
<demo-block>
        
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;ShTable
    :pageShow=&quot;false&quot;
    :data=&quot;tableData&quot;
    :total=&quot;total&quot;
    :page-sizes=&quot;[10, 20, 30, 40]&quot;
    layout=&quot;sizes, prev, pager, next,total&quot;
    :current-page.sync=&quot;pageIndex&quot;
    @page-current-change=&quot;pageChange&quot;
    @size-change=&quot;pageSizeChange&quot;
  &gt;
    &lt;el-table-column v-for=&quot;item in  columnConfig&quot; :key=&quot;item.key&quot; :field=&quot;item.key&quot; :label=&quot;item.name&quot; :prop=&quot;item.key&quot;&gt; &lt;/el-table-column&gt;
  &lt;/ShTable&gt;
&lt;/template&gt;
&lt;script&gt;
  const TableMixin = require('#/mixins/TableMixin').default
  export default {
    data() {
      return {
        tableData: [
          { id: 10001, name: 'Test1', role: 'Develop', sex: 'Man', age: 28, address: 'test abc' },
          { id: 10002, name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
          { id: 10003, name: 'Test3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
          { id: 10004, name: 'Test4', role: 'Designer', sex: 'Women', age: 24, address: 'Shanghai' }
        ],
        total: 100,
        columnConfig: [
          {
            key: 'name',
            name: '姓名',
            visible: true, // 是否展示在表格列中
            sortable: true, // 是否可以排序
            fixed: null, // 固定列的位置(left, right)
            width: null // 默认宽度，像素
          },
          {
            key: 'sex',
            name: '性别',
            visible: true, // 是否展示在表格列中
            sortable: true, // 是否可以排序
            fixed: null, // 固定列的位置(left, right)
            width: null // 默认宽度，像素
          },
          {
            key: 'age',
            name: '年龄',
            visible: true, // 是否展示在表格列中
            sortable: true, // 是否可以排序
            fixed: null, // 固定列的位置(left, right)
            width: null // 默认宽度，像素
          }
        ]
      }
    },
    mixins: [TableMixin],
    created() {
      this.getTableList()
    },
    methods: {
      // 获取表格基础数据
      getTableList() {}
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>page-show</td>
<td>是否需要分页</td>
<td>布尔类型</td>
<td>true,false</td>
<td>true</td>
</tr>
<tr>
<td>page-align</td>
<td>分页对齐方式</td>
<td>布尔类型</td>
<td>left,center,right</td>
<td>right</td>
</tr>
</tbody>
</table>
<h3 id="fang-fa"><a class="header-anchor" href="#fang-fa">¶</a> 方法</h3>
<table>
<thead>
<tr>
<th>方法名</th>
<th>说明</th>
<th>回掉参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>page-current-change</td>
<td>分页改变,原分页改变与 elemenui table 组件方法冲突，需自定义函数名</td>
<td>当前页码</td>
</tr>
</tbody>
</table>
<h3 id="ref-diao-yong"><a class="header-anchor" href="#ref-diao-yong">¶</a> Ref 调用</h3>
<table>
<thead>
<tr>
<th>组件</th>
<th>说明</th>
<th>事例</th>
</tr>
</thead>
<tbody>
<tr>
<td>表格组件</td>
<td>elTableRef</td>
<td>this.$refs.shTableRef.$refs.elTableRef</td>
</tr>
<tr>
<td>element 分页器组件</td>
<td>elPaginationRef</td>
<td>this.$refs.shTableRef.$refs.elPaginationRef</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ShTable',{ref:"shTableRef",attrs:{"data":_vm.tableData,"total":_vm.total,"page-sizes":[ 20, 30, 40],"layout":"sizes, prev, pager, next,total","current-page":_vm.pageIndex},on:{"update:currentPage":function($event){_vm.pageIndex=$event},"update:current-page":function($event){_vm.pageIndex=$event},"page-current-change":_vm.pageChange,"size-change":_vm.pageSizeChange}},[_c('el-table-column',{attrs:{"type":"seq","width":"60"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sex","label":"Sex"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"age","label":"Age"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.age))]}}])})],1)]],2)}
var staticRenderFns = []

  
    // 不是必须项导入可以减少代码书写量
  // import TableMixin from 'sh-ui-v2/packages/mixins/TableMixin'
  const TableMixin = require('#/mixins/TableMixin').default
  const democomponentExport = {
    data() {
      return {
        tableData: [
          { id: 10001, name: 'Test1', role: 'Develop', sex: 'Man', age: 28, address: 'test abc' },
          { id: 10002, name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
          { id: 10003, name: 'Test3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
          { id: 10004, name: 'Test4', role: 'Designer', sex: 'Women', age: 24, address: 'Shanghai' }
        ],
        total: 100
      }
    },
    mixins: [TableMixin],
    created() {
      this.getTableList()
    },
    mounted() {
      // 获取表格事件
      // console.log(this.$refs.shTableRef.$refs.elTableRef)
      // 获取分页器事件
      // console.log(this.$refs.shTableRef.$refs.elPaginationRef)
    },
    methods: {
      // 获取表格基础数据
      // 组件内重写getTableList方法，覆盖mixin内此方法
      getTableList() {
        // 获取表格数据
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ShTable',{attrs:{"pageShow":false,"data":_vm.tableData,"total":_vm.total,"page-sizes":[10, 20, 30, 40],"layout":"sizes, prev, pager, next,total","current-page":_vm.pageIndex},on:{"update:currentPage":function($event){_vm.pageIndex=$event},"update:current-page":function($event){_vm.pageIndex=$event},"page-current-change":_vm.pageChange,"size-change":_vm.pageSizeChange}},[_c('el-table-column',{attrs:{"type":"seq","width":"60"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.name))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sex","label":"Sex"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.sex))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"age","label":"Age"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.age))]}}])})],1)]],2)}
var staticRenderFns = []

  
    const TableMixin = require('#/mixins/TableMixin').default
  const democomponentExport = {
    data() {
      return {
        tableData: [
          { id: 10001, name: 'Test1', role: 'Develop', sex: 'Man', age: 28, address: 'test abc' },
          { id: 10002, name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
          { id: 10003, name: 'Test3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
          { id: 10004, name: 'Test4', role: 'Designer', sex: 'Women', age: 24, address: 'Shanghai' }
        ],
        total: 100
      }
    },
    mixins: [TableMixin],
    created() {
      this.getTableList()
    },
    methods: {
      // 获取表格基础数据
      getTableList() {}
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ShTable',{attrs:{"pageShow":false,"data":_vm.tableData,"total":_vm.total,"page-sizes":[10, 20, 30, 40],"layout":"sizes, prev, pager, next,total","current-page":_vm.pageIndex},on:{"update:currentPage":function($event){_vm.pageIndex=$event},"update:current-page":function($event){_vm.pageIndex=$event},"page-current-change":_vm.pageChange,"size-change":_vm.pageSizeChange}},_vm._l((_vm.columnConfig),function(item){return _c('el-table-column',{key:item.key,attrs:{"field":item.key,"label":item.name,"prop":item.key}})}),1)]],2)}
var staticRenderFns = []

  
    const TableMixin = require('#/mixins/TableMixin').default
  const democomponentExport = {
    data() {
      return {
        tableData: [
          { id: 10001, name: 'Test1', role: 'Develop', sex: 'Man', age: 28, address: 'test abc' },
          { id: 10002, name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
          { id: 10003, name: 'Test3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
          { id: 10004, name: 'Test4', role: 'Designer', sex: 'Women', age: 24, address: 'Shanghai' }
        ],
        total: 100,
        columnConfig: [
          {
            key: 'name',
            name: '姓名',
            visible: true, // 是否展示在表格列中
            sortable: true, // 是否可以排序
            fixed: null, // 固定列的位置(left, right)
            width: null // 默认宽度，像素
          },
          {
            key: 'sex',
            name: '性别',
            visible: true, // 是否展示在表格列中
            sortable: true, // 是否可以排序
            fixed: null, // 固定列的位置(left, right)
            width: null // 默认宽度，像素
          },
          {
            key: 'age',
            name: '年龄',
            visible: true, // 是否展示在表格列中
            sortable: true, // 是否可以排序
            fixed: null, // 固定列的位置(left, right)
            width: null // 默认宽度，像素
          }
        ]
      }
    },
    mixins: [TableMixin],
    created() {
      this.getTableList()
    },
    methods: {
      // 获取表格基础数据
      getTableList() {}
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  